import styled from 'styled-components';
import { lineHeight } from '../style';

export const ErrorText = styled.span`
  margin-top: ${lineHeight / 2}px;
  color: var(--error-text-color);
  height: ${lineHeight}px;
`;
